"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.approvalQueue.title': 'Approval Queue',
    'socialMediaPlan.approvalQueue.desc': 'Posts waiting for review before publishing',
    'socialMediaPlan.approvalQueue.proposedDate': 'Proposed date:',
    'socialMediaPlan.approvalQueue.preview': 'Preview',
    'socialMediaPlan.approvalQueue.reject': 'Reject',
    'socialMediaPlan.approvalQueue.approve': 'Approve',
    'socialMediaPlan.approvalQueue.rejectConfirm': 'Reject this post and move back to draft?',
    'socialMediaPlan.approvalQueue.approved': 'Post approved for scheduling',
    'socialMediaPlan.approvalQueue.rejected': 'Post moved back to draft',
};
